import { type ReactNode } from 'react'
import { type GameApp } from '@app-types/api/auth'

interface GameAppCardProps {
  app: GameApp
  dragHandle?: ReactNode
  isFavorite: boolean
  onToggleFavorite: (appId: number) => void
}

function GameAppCard({
  app,
  dragHandle,
  isFavorite,
  onToggleFavorite,
}: GameAppCardProps) {
  return (
    <div className="relative grid min-h-20 min-w-0 rounded-lg border border-slate-200 bg-white text-sm font-semibold text-slate-800 transition hover:border-violet-300 hover:bg-violet-50 hover:text-violet-900 dark:border-zinc-800 dark:bg-zinc-900 dark:text-slate-100 dark:hover:border-violet-700 dark:hover:bg-violet-950/30 dark:hover:text-white">
      {dragHandle}
      <a
        className={`grid min-w-0 py-3 pr-11 text-inherit no-underline ${
          dragHandle ? 'pl-11' : 'pl-4'
        }`}
        href={app.url}
      >
        <span className="min-w-0 truncate">{app.name}</span>
        <span className="mt-1 min-w-0 truncate text-[11px] leading-4 font-medium text-slate-500 dark:text-slate-400">
          {app.slug}
        </span>
      </a>
      <button
        aria-label={
          isFavorite ? 'Убрать игру из избранного' : 'Добавить игру в избранное'
        }
        aria-pressed={isFavorite}
        className={`absolute top-2 right-2 grid size-7 place-items-center rounded-md border text-base leading-none transition ${
          isFavorite
            ? 'border-amber-300 bg-amber-50 text-amber-600 hover:bg-amber-100 dark:border-amber-700 dark:bg-amber-950/40 dark:text-amber-300'
            : 'border-slate-200 bg-white text-slate-400 hover:border-amber-300 hover:text-amber-500 dark:border-zinc-700 dark:bg-zinc-950 dark:text-zinc-500 dark:hover:border-amber-700 dark:hover:text-amber-300'
        }`}
        onClick={() => onToggleFavorite(app.id)}
        onPointerDown={(event) => event.stopPropagation()}
        title={
          isFavorite ? 'Убрать игру из избранного' : 'Добавить игру в избранное'
        }
        type="button"
      >
        {isFavorite ? '★' : '☆'}
      </button>
    </div>
  )
}

export default GameAppCard
